import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {INormalWinConfig, NORMAL_WIN_LEVEL_NAMES} from "../server/IKMDData";
import {KMDGameMode} from "../server/KMDGameMode";
import {KMDSound} from "../sound/KMDSound";

export class KMDNormalWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return KennethMustDie.model.isNormalWin;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            totalAvalancheRoundWinnings: number = KennethMustDie.model.gameData.totalAvalancheRoundWinnings,
            useTotalWin: boolean = (KennethMustDie.model.gameData.mode !== KMDGameMode.NORMAL || KennethMustDie.model.gameData.nextMode !== KMDGameMode.NORMAL),
            winConfig: INormalWinConfig = KennethMustDie.model.getNormalWinConfig();

        // #362
        if (KennethMustDie.isSingleWinBelowStake()) {
            controller.setSkipCallback(() => {
            });

            KennethMustDie.setKeypadWin(useTotalWin);

            return;
        }

        // #451
        if (winConfig.duration > 0.1) {
            tl.add([
                () => {
                    controller.setSkipCallback(() => {
                        this.onSkip(tl);
                    });

                    KennethMustDie.countUp.stopAt(0);
                    KennethMustDie.countUp.preCalculateScale(0, totalAvalancheRoundWinnings);
                    KennethMustDie.countUp.getReady(180);

                    // #415
                    if (winConfig.name === NORMAL_WIN_LEVEL_NAMES.LARGE) {
                        KennethMustDie.soundPlayer.playSound(KMDSound.WIN_LARGE_COUNT_UP);
                    }
                },
                KennethMustDie.countUp.getCountAnimation(0, totalAvalancheRoundWinnings, winConfig.duration)
            ]);
        }

        tl.add(() => {
            // #451
            if (winConfig.duration < 0.1) {
                KennethMustDie.countUp.getReady(180, 1);
            }

            // #415
            if (winConfig.name === NORMAL_WIN_LEVEL_NAMES.LARGE) {
                KennethMustDie.soundPlayer.playSound(KMDSound.WIN_LARGE_END);
            } else if (winConfig.name === NORMAL_WIN_LEVEL_NAMES.MEDIUM) {
                KennethMustDie.soundPlayer.playSound(KMDSound.WIN_MEDIUM);
            } else if (winConfig.name === NORMAL_WIN_LEVEL_NAMES.SMALL) {
                KennethMustDie.soundPlayer.playSound(KMDSound.WIN_SMALL);
            } else if (winConfig.name === NORMAL_WIN_LEVEL_NAMES.TINY) {
                KennethMustDie.soundPlayer.playSound(KMDSound.WIN_TINY);
            }

            // #441
            KennethMustDie.countUp.stopAt(totalAvalancheRoundWinnings);

            KennethMustDie.setKeypadWin(useTotalWin);
        });
        tl.to(this, {
            duration: 0.7
        });
        tl.to(KennethMustDie.countUp, {
            duration: 0.5,
            alpha: 0
        });
        tl.add(() => {
            KennethMustDie.countUp.visible = false;
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}